import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { Users, Layers } from 'lucide-react';

import { buildNameColumn } from '@@/datatables/buildNameColumn';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { EnvironmentGroup } from '../../types';

const columnHelper = createColumnHelper<EnvironmentGroup>();

export const columns = [
  buildNameColumn<EnvironmentGroup>('Name', '.group', 'environment-group-name'),
  columnHelper.display({
    header: 'Actions',
    cell: ActionsCell,
  }),
];

function ActionsCell({
  row: { original: item },
}: CellContext<EnvironmentGroup, unknown>) {
  const isUnassignedGroup = item.Id === 1;
  // only the unassigned group cannot have policies assigned to it
  const isPoliciesEnabledForEnvironment = !isUnassignedGroup;

  const managePoliciesButton = (
    <Button
      as={isPoliciesEnabledForEnvironment ? Link : 'button'}
      props={
        isPoliciesEnabledForEnvironment
          ? {
              to: 'portainer.policies',
              params: { id: item.Id },
            }
          : undefined
      }
      color="link"
      className="!pl-0"
      icon={Layers}
      disabled={!isPoliciesEnabledForEnvironment}
      data-cy={`manage-policies-button_${item.Name}`}
    >
      Manage policies
    </Button>
  );

  return (
    <div className="flex gap-x-2">
      {isPoliciesEnabledForEnvironment ? (
        managePoliciesButton
      ) : (
        <TooltipWithChildren message="Policies cannot be assigned to the unassigned group. Create an environment group first">
          <span>{managePoliciesButton}</span>
        </TooltipWithChildren>
      )}
      <Button
        as={Link}
        props={{
          to: '.group.access',
          params: { id: item.Id },
        }}
        color="link"
        icon={Users}
        data-cy={`manage-access-button_${item.Name}`}
      >
        Manage access
      </Button>
    </div>
  );
}
